export default {"src":"/_next/static/media/microwave.a241157a.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};